import { CardsWrapper, SectionContainer } from './styles';
import PixIcon from 'assets/icons/pix-icon.svg?react';
import CreditCardOffIcon from 'assets/icons/credit-card-off.svg?react';
import SecurityIcon from 'assets/icons/security.svg?react';
import { FeatureCard } from 'shared/components/cards/BenefitsCard';

export const BenefitsSection = () => {
  const options = [
    {
      id: 1,
      title: 'Entrada que cabe no seu bolso',
      description: 'No final do processo, você realizará o pagamento da entrada via PIX.',
      icon: <PixIcon />,
    },
    {
      id: 2,
      title: 'Pagamento em 18x sem cartão',
      description: 'Aproveite seus créditos e pague parcelado seu smartphone Motorola.',
      icon: <CreditCardOffIcon />,
    },
    {
      id: 3,
      title: 'Análise com DimoSafe',
      description: 'Sistema de segurança exclusivo da Motorola onde ajudará com o pagamento.',
      icon: <SecurityIcon />,
    },
  ];

  return (
    <SectionContainer
      initial={{ y: 50, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <CardsWrapper>
        {options.map((opt, index) => 
          <FeatureCard item={opt} index={index} key={index} />
        )}
      </CardsWrapper>
    </SectionContainer>
  );
};
